import { render } from "./hidden-messages.vue?vue&type=template&id=073d037c&scoped=true"
import script from "./hidden-messages.vue?vue&type=script&lang=js"
export * from "./hidden-messages.vue?vue&type=script&lang=js"

import "./hidden-messages.vue?vue&type=style&index=0&id=073d037c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073d037c"]])

export default __exports__